import type { NPCData } from '@/modules/game-domain/world.types';
import { stableIndividualIdleCharacter } from './individual-idle-assets';
import { meshyNpcModel, type MeshyNpcModel } from './meshy-npc-clips';

// The authoring API permits adult appearances for every service role. Keep the
// legacy role binding separate so older layouts retain their exact stable art.
const serviceAppearances = new Set([
  'road_gossip', 'road_merchant', 'road_blacksmith', 'road_sage', 'innkeeper_v1',
  'bounty_hunter_v1', 'healer_v1', 'herald_v1', 'weapon_smith_v1',
]);

export function serviceNpcModel(npc: Pick<NPCData, 'id' | 'type' | 'nameKey' | 'townId' | 'appearanceKey'>): MeshyNpcModel | null {
  if (npc.appearanceKey && serviceAppearances.has(npc.appearanceKey)) return meshyNpcModel(npc.appearanceKey);
  const legacy = stableIndividualIdleCharacter(npc.id, npc.type, npc.nameKey, npc.townId);
  return legacy ? meshyNpcModel(legacy) : null;
}
